import React from 'react'
import styled from 'styled-components'
import card_visit_detailStyles from './card_visit_detail.styles'

const apAtomName = {ap_atom_name: 'apCardVisitDetailAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${card_visit_detailStyles}
`

const CardVisitDetailAtom: React.FC = function ({children}) {
  return <StyledWrapper {...apAtomName}>{children}</StyledWrapper>
}

export default CardVisitDetailAtom
